import React from 'react'
import ControllerDashboard from './ControllerDashboard'
const index = () => <ControllerDashboard />

export default index